module.exports = __webpack_public_path__ + "static/media/watchmaker.1cb0b694.jpeg";